// extracted by mini-css-extract-plugin
export default {"container":"RE-z","innerContainer":"SE-z","multipleLines":"TE-z","heading":"UE-z","content":"VE-z","linkColor":"WE-z"};